<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      title="添加 核销单"
      line-form
      :data="data"
      @create-opened="onCreateOpened"
      :form-rules="rules"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row class="border">
          <el-row>
            <el-col :span="6">
              <el-form-item label="单据编号" prop="DocNo">
                <span class="detail-span" v-if="Mode==0">{{data.DocNo}}</span>
                <el-input v-else v-model="data.DocNo" placeholder="请输入单据编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据日期" prop="DocDate">
                <el-date-picker
                  type="date"
                  v-model="data.DocDate"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="经办人" prop="ClerkId">
                <select-input
                  placeholder="请选择经办人"
                  :label="data.ClerkName"
                  v-model="data.ClerkId"
                  @click="openEmp"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="核销类型">
                <span class="detail-span" v-if="data.CancelTypeId==0">收款核销</span>
                <span class="detail-span" v-else>付款核销</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="往来单位">
                <span class="detail-span">{{data.TradeUnitName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="data.Memo" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-row>
        <div class="row-tb-head" style="margin:10px 0;">
          <span v-if="data.CancelTypeId==0">收款单明细</span>
          <span v-else>付款单明细</span>
        </div>
        <el-table
          class="tb-c-head"
          border
          show-summary
          :data="data.SRpDts"
          @selection-change="x=>data.RpDts=x"
        >
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column label="单据日期" min-width="120">
            <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
          </el-table-column>
          <el-table-column label="单据编号" min-width="150" show-overflow-tooltip>
            <template slot-scope="{row}">{{row.DocNo}}</template>
          </el-table-column>
          <el-table-column label="往来单位" min-width="150">
            <template slot-scope="{row}">{{row.TradeUnitName}}</template>
          </el-table-column>
          <el-table-column label="部门" min-width="100">
            <template slot-scope="{row}">{{row.DpName}}</template>
          </el-table-column>
          <el-table-column label="经办人" min-width="100">
            <template slot-scope="{row}">{{row.ClerkName}}</template>
          </el-table-column>
          <el-table-column label="金额" prop="Amount" width="120" />
          <el-table-column label="应核销金额" prop="NoSettleAmount" width="120" />
          <el-table-column label="本次核销金额" prop="WriteoffAmount" width="120">
            <template slot-scope="{row}">
              <el-input @input="onInput(row,'WriteoffAmount')" v-model="row.WriteoffAmount"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column label="累计核销金额" prop="TotalAmount" width="120" /> -->
        </el-table>
        <div class="row-tb-head" style="margin:10px 0;">
          <span>核销明细</span>
        </div>
        <el-table
          class="tb-c-head"
          border
          show-summary
          :data="data.SWoDts"
          @selection-change="x=>data.WoDts=x"
        >
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column label="单据类型" min-width="80">
            <template slot-scope="{row}">{{row.SourceTypeName}}</template>
          </el-table-column>
          <el-table-column label="单据日期" min-width="100">
            <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
          </el-table-column>
          <el-table-column label="单据编号" min-width="150" show-overflow-tooltip>
            <template slot-scope="{row}">{{row.DocNo}}</template>
          </el-table-column>
          <el-table-column label="往来单位" min-width="150">
            <template slot-scope="{row}">{{row.TradeUnitName}}</template>
          </el-table-column>
          <!-- <el-table-column label="部门" min-width="90">
            <template slot-scope="{row}">{{row.DpName}}</template>
          </el-table-column>-->
          <el-table-column label="经办人" min-width="90">
            <template slot-scope="{row}">{{row.ClerkName}}</template>
          </el-table-column>
          <!-- <el-table-column label="明细编号" min-width="120" show-overflow-tooltip>
            <template slot-scope="{row}">{{row.DetailNo}}</template>
          </el-table-column> -->
          <el-table-column label="明细名称" min-width="100">
            <template slot-scope="{row}">{{row.DetailName}}</template>
          </el-table-column>
          <el-table-column label="金额" prop="Amount" width="90" />
          <el-table-column label="应核销金额" prop="NoSettleAmount" width="90" />
          <el-table-column label="本次核销金额" prop="WriteoffAmount" width="110">
            <template slot-scope="{row}">
              <el-input @input="onInput(row,'WriteoffAmount')" v-model="row.WriteoffAmount"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
        <el-button size="mini" type="primary" @click="save">保 存</el-button>
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
      <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import empDialog from "@/components/sales/business/empDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    empDialog,
  },
  data() {
    return {
      api: require("@/api/fund/contactcash/woDoc").default,
      code_api: require("@/api/sy/bill").default,
      receipt_api: require("@/api/fund/receipt").default,
      pay_api: require("@/api/fund/paydoc").default,
      // pay_api:"",
      data: {
        WoDocId: 0,
        CancelTypeId: 0, //收款核销/付款核销
        DocNo: "",
        FirstUnitId: null,
        TradeUnitName: "",
        SecondUnitId: null,
        DocDate: this.$commonJs.getToday(),
        ClerkId: null,
        ClerkName: "",
        Memo: "",
        RpDts: [], //核销单收付款单
        SRpDts: [],
        WoDts: [], //核销单核销明细
        SWoDts: [],
      },
      Mode: 0,
      rules: {
        DocNo: [{ required: true, message: "收入单编号不能为空" }],
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        FirstUnitId: [{ required: true, message: "请选择往来单位单位" }],
        ClerkId: [{ required: true, message: "请选择经办人" }],
      },
    };
  },
  computed: {
    SelectAmount() {
      var list = this.data.RpDts.map((x) => x.WriteoffAmount);
      if (list.length > 0) return list.reduce((a, b) => a + b);
      else return 0;
    },
  },
  watch: {
    SelectAmount() {
      var s_amount = this.SelectAmount;
      for (let i = 0; i < this.data.SWoDts.length; i++) {
        var ns_amount = this.data.SWoDts[i].NoSettleAmount;
        var amount = s_amount - ns_amount;
        
        if (amount >= 0) {
          this.data.SWoDts[i].WriteoffAmount = ns_amount;
          s_amount = amount;
        } else {
          this.data.SWoDts[i].WriteoffAmount = s_amount;
          break;
        }
      }
    },
  },
  methods: {
    onCreateOpened(data) {
      
      this.code_api.getDefaultSerialNo("核销单").then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data;
        } else {
          this.$message.warning("获取核销单编号失败");
        }
      });
      this.data.CancelTypeId = data.BusinessType;
      this.data.FirstUnitId = data.TradeUnitId;
      this.data.SecondUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.TradeUnitName;

      var user = this.$store.state.user;
      
      this.data.ClerkId = user.empId;
      this.data.ClerkName = user.name;

      var parmas = {
        TradeUnitId: data.TradeUnitId,
        DocDateStart: data.DocDateStart,
        DocDateEnd: data.DocDateEnd,
        BusinessTypes: [0, 2],
      };
      if (this.data.CancelTypeId == 0) {
        this.receipt_api.alreadyList(parmas).then((res) => {
          if (res.Data) {
            //核销单收付款单
            this.data.SRpDts = res.Data.map((x, i) => {
              return {
                Index: i,
                WoDocRpId: 0,
                WoDocId: this.data.WoDocId,
                SourceTypeId: x.SourceTypeId,
                SrcVouTypeName: x.SrcVouTypeName,
                DocId: x.DocId,
                DocNo: x.DocNo,
                TradeUnitId: x.TradeUnitId,
                TradeUnitName: x.TradeUnitName,
                DocDate: x.DocDate,
                DpId: x.DpId,
                DpName: x.DpName,
                ClerkId: x.EmpId,
                ClerkName: x.EmpName,
                // ProjectId: null,
                Amount: x.ReceiptAmount,
                NoSettleAmount: x.ReceiptAmount - x.WriteoffAmount,
                WriteoffAmount: x.ReceiptAmount - x.WriteoffAmount,
                TotalAmount: x.WriteoffAmount,
                Memo: x.Remark,
                BusinessTypeId: x.BusinessType,
                SourceVoucherId: x.SourceId,
                SourceVoucherTypeId: x.SourceType,
                SourceCode: x.SourceNo,
                IsSelected: false,
                T: 0,
              };
            });
          }
        });
        this.api.needRcvDetail(data).then((res) => {
          if (res.Data) {
            //核销单核销明细
            this.data.SWoDts = res.Data.map((x, i) => {
              return {
                Index: i,
                WoDocWoId: 0,
                WoDocId: this.data.WoDocId,
                SourceTypeId: x.SrcVouType,
                SourceTypeName: x.SrcVouTypeName,
                DocId: x.DocId,
                DetailId: x.DetailId,
                DetailName: x.DetailName,
                DocNo: x.DocNo,
                // TypeId: 0,
                TradeUnitId: x.TradeUnitId,
                TradeUnitName: x.TradeUnitName,
                DocDate: x.DocDate,
                DpId: x.DpId,
                DpName: x.DpName,
                ClerkId: x.EmpId,
                ClerkName: x.EmpName,
                // ProjectId: 0,
                Amount: x.Amount,
                NoSettleAmount: x.Amount - x.WriteoffAmount,
                WriteoffAmount: 0,
                TotalAmount: x.WriteoffAmount,
                Memo: "",
                BusinessTypeId: 0,
                SourceVoucherId: x.SourceId,
                SourceVoucherTypeId: x.SrcVouType,
                // SourceCode: null,
                IsSelected: false,
                T: 0,
              };
            });
          }
        });
      } else {
        this.pay_api.alreadyPayDocList(parmas).then((res) => {
          if (res.Data) {
            this.data.SRpDts = res.Data.map((x, i) => {
              return {
                Index: i,
                WoDocRpId: 0,
                WoDocId: this.data.WoDocId,
                SourceTypeId: x.SourceTypeId,
                SrcVouTypeName: x.SrcVouTypeName,
                DocId: x.DocId,
                DocNo: x.DocNo,
                TradeUnitId: x.TradeUnitId,
                TradeUnitName: x.TradeUnitName,
                DocDate: x.DocDate,
                // DpId: null,
                ClerkId: x.EmpId,
                ClerkName: x.EmpName,
                // ProjectId: null,
                Amount: x.PayAmount,
                NoSettleAmount: x.PayAmount - x.WriteoffAmount,
                WriteoffAmount: x.PayAmount - x.WriteoffAmount,
                TotalAmount: x.WriteoffAmount,
                Memo: "",
                BusinessTypeId: x.BusinessType,
                SourceVoucherId: x.SourceId,
                SourceVoucherTypeId: x.SourceType,
                SourceCode: x.SourceNo,
                IsSelected: false,
                T: 0,
              };
            });
          }
        });
        this.api.needPayDetail(data).then((res) => {
          if (res.Data) {
            this.data.SWoDts = res.Data.map((x, i) => {
              return {
                Index: i,
                WoDocWoId: 0,
                WoDocId: this.data.WoDocId,
                SourceTypeId: x.SrcVouType,
                SourceTypeName: x.SrcVouTypeName,
                DocId: x.DocId,
                DetailId: x.DetailId,
                DetailName: x.DetailName,
                DocNo: x.DocNo,
                // TypeId: 0,
                TradeUnitId: x.TradeUnitId,
                TradeUnitName: x.TradeUnitName,
                DocDate: x.DocDate,
                DpId: x.DpId,
                DpName: x.DpName,
                ClerkId: x.EmpId,
                ClerkName: x.EmpName,
                // ProjectId: 0,
                Amount: x.Amount,
                NoSettleAmount: x.Amount - x.WriteoffAmount,
                WriteoffAmount: 0,
                TotalAmount: x.WriteoffAmount,
                Memo: "",
                BusinessTypeId: 0,
                SourceVoucherId: x.SourceId,
                SourceVoucherTypeId: x.SrcVouType,
                // SourceCode: null,
                IsSelected: false,
                T: 0,
              };
            });
          }
        });
      }
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setEmp(data) {
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
    },
    onInput(row, type) {
      row.T = row.T == 0 ? 0 : 1;
      row[type] = this.$commonJs.obj.toNumber(row[type]);
      if (row.WriteoffAmount > row.NoSettleAmount) {
        row.WriteoffAmount = row.NoSettleAmount;
      }
    },
    // onInput2(row, type) {
    //   row.T = row.T == 0 ? 0 : 1;
    //   row[type] = this.$commonJs.obj.toNumber(row[type]);
    //   if (row.WriteoffAmount > row.NoSettleAmount) {
    //     row.WriteoffAmount = row.NoSettleAmount;
    //   }
    // },
    save() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        var text = "";
        if (this.data.CancelTypeId == 0) text = "收款单明细";
        else text = "付款单明细";

        if (this.data.RpDts.length == 0) {
          this.$message.warning("请选择" + text);
          return;
        }
        var amount1 = this.data.RpDts.some((x) => x.WriteoffAmount <= 0);
        if (amount1) {
          this.$message.warning(text + " - 本次核销金额不能为空且需大于0");
          return false;
        }

        if (this.data.WoDts.length == 0) {
          this.$message.warning("请选择核销单据");
          return;
        }
        var amount2 = this.data.WoDts.some((x) => x.WriteoffAmount <= 0);
        if (amount2) {
          this.$message.warning("核销单据 - 本次核销金额不能为空且需大于0");
          return false;
        }

        var total1 = this.data.RpDts.map((x) => x.WriteoffAmount).reduce(
          (a, b) => parseFloat(a) + parseFloat(b)
        );
        var total2 = this.data.WoDts.map((x) => x.WriteoffAmount).reduce(
          (a, b) => parseFloat(a) + parseFloat(b)
        );
        if (total1 != total2) {
          this.$message.warning(
            "已选" + text + "金额总和需等于已选核销单据金额总和"
          );
          return false;
        }

        var data = this.$commonJs.obj.removeNullKey(this.data);

        // this.data.WoDts.forEach((x) => {
        //   var wo = data.SWoDts.find((w) => w.Index == x.Index);
        //   wo.IsSelected = true;
        // });
        // this.data.RpDts.forEach((x) => {
        //   var rp = data.SRpDts.find((w) => w.Index == x.Index);
        //   rp.IsSelected = true;
        // });
        
        this.$refs.dialog.isLoading = true;
        this.api.save(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.$emit("close-saved");
            this.close(true);
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    onClosed() {
      this.data.RpDts = []; //核销单收付款单
      this.data.SRpDts = [];
      this.data.WoDts = []; //核销单核销明细
      this.data.SWoDts = [];
    },
  },
};
</script> 
<style lang="scss" scoped>
.border{
  padding: 15px;
}
</style>